import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ScrollRestoration from '../ScrollRestoration/ScrollRestoration';
import { ReactComponent as ToolboxIcon } from '../../assets/icons/Toolbox.svg'; // no modulor icon
import Local from '../Local/Local';
import { NAMESPACES } from '../../constants/namespaces';
import { isNativeSelector } from '../../redux/reducers/app/params';
import styles from './Maintenance.module.css';
import { Button } from '@modulor/react';

const Maintenance = () => {
  const history = useHistory();
  const isNative = useSelector(isNativeSelector);

  const onClick = () => {
    // INFO: do not change it to RouterContext goBack function
    history.goBack();
  };

  return (
    <ScrollRestoration>
      <section className={styles['lc-Maintenance']}>
        <div className={styles['lc-wrapper']}>
          <ToolboxIcon className={styles['lc-icon']} data-testid="toolbox" />
          <h1 className={styles['lc-title']}>
            <Local namespace={NAMESPACES.MAINTENANCE}>Technical issues</Local>
          </h1>
          <p className={styles['lc-description']}>
            <Local namespace={NAMESPACES.MAINTENANCE}>
              At the moment, we are trying to restore the service
            </Local>
          </p>
          {!isNative && (
            <Button className={styles['lc-button']} onClick={onClick}>
              <Local namespace={NAMESPACES.MAINTENANCE}>Go back</Local>
            </Button>
          )}
        </div>
      </section>
    </ScrollRestoration>
  );
};

export default Maintenance;
